import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const API_URL = (typeof window !== 'undefined' && window.location.hostname === 'app.salesqualifyd.com')
  ? 'https://app.salesqualifyd.com/api'
  : `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PublicWebForm() {
  const { orgId, formId } = useParams();
  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(true);
  const [fields, setFields] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchForm = async () => {
      try {
        const res = await axios.get(`${API_URL}/webforms/public/${formId}`);
        setForm(res.data);
      } catch (err) {
        setError('Form not found');
      } finally {
        setLoading(false);
      }
    };
    fetchForm();
  }, [formId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await axios.post(`${API_URL}/webforms/public/${formId}/submit`, fields);
      setSubmitted(true);
    } catch (err) {
      setError('Submission failed. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px', fontFamily: 'Arial, sans-serif' }}>Loading form...</div>;
  if (error && !form) return <div style={{ textAlign: 'center', padding: 40, fontFamily: 'Arial, sans-serif', color: '#666' }}>{error}</div>;
  if (submitted) return (
    <div style={{ textAlign: 'center', padding: 40, fontFamily: 'Arial, sans-serif' }}>
      <div style={{ fontSize: 48, marginBottom: 16 }}>&#10003;</div>
      <h2 style={{ color: '#15803D', marginBottom: 8 }}>Thank you!</h2>
      <p style={{ color: '#666' }}>Your submission has been received.</p>
    </div>
  );

  const formFields = form?.fields || [];

  return (
    <div style={{ maxWidth: 500, margin: '0 auto', padding: 24, fontFamily: 'Arial, sans-serif' }}>
      {form?.title && <h2 style={{ marginBottom: 16, fontSize: '1.25rem', fontWeight: 600, color: '#111' }}>{form.title}</h2>}
      <form onSubmit={handleSubmit}>
        {formFields.map((field, i) => (
          <div key={i} style={{ marginBottom: 14 }}>
            <label style={{ display: 'block', fontSize: 14, fontWeight: 600, marginBottom: 4, color: '#333' }}>
              {field.label}{field.required && <span style={{ color: '#ef4444' }}> *</span>}
            </label>
            {field.type === 'textarea' ? (
              <textarea
                name={field.label}
                required={field.required}
                rows={3}
                style={{ width: '100%', padding: '8px 12px', border: '1px solid #ddd', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' }}
                onChange={e => setFields({ ...fields, [field.label]: e.target.value })}
              />
            ) : (
              <input
                type={field.type || 'text'}
                name={field.label}
                required={field.required}
                style={{ width: '100%', padding: '8px 12px', border: '1px solid #ddd', borderRadius: 6, fontSize: 14, boxSizing: 'border-box' }}
                onChange={e => setFields({ ...fields, [field.label]: e.target.value })}
              />
            )}
          </div>
        ))}
        <button
          type="submit"
          disabled={submitting}
          style={{ background: '#f97316', color: '#fff', padding: '10px 24px', border: 'none', borderRadius: 6, fontSize: 14, cursor: 'pointer', width: '100%' }}
        >
          {submitting ? 'Submitting...' : 'Submit'}
        </button>
        {error && <p style={{ color: '#ef4444', fontSize: 13, marginTop: 8 }}>{error}</p>}
      </form>
    </div>
  );
}
